 <template> 
    <v-dialog v-model="restart_job_dialog" v-on:click:outside="close_dialog($event)" @keydown.esc="close_dialog($event)" max-width="600px">
      <v-form width="250" ref="restart_job_form" lazy-validation>
        <v-card>
          <v-alert v-if="restart_job_error" class="error my-0 pa-2" tile>
            <v-icon small class="pb-1">warning</v-icon>
            <span class="subtitle-1 font-weight-medium pl-2">{{restart_job_error}}</span>
          </v-alert>
          <v-btn class="float-right" fab dark small text @click="close_dialog">
            <v-icon dark>mdi-close</v-icon>
          </v-btn>
          <v-card-title>
            <span class="subtitle-1 font-weight-medium grey darken-3 px-2">Are you sure you want to restart this job?</span>
          </v-card-title>
          <v-card-text class="py-0">
            <v-container class="pa-0">
              <v-row v-if="can_change_machine_type">
                <v-col cols="4">
                  Machine Type*
                </v-col>
                <v-col class="py-0" cols="8">
                  <v-combobox
                    v-model="machine_type"
                    :items="machines"
                    item-text="name"
                    item-value="id"
                    class="pa-0 ml-1"
                    :rules="machineTypeRules"
                  >
                  </v-combobox>
                </v-col>
              </v-row>
              <v-row class="mb-4" v-if="can_change_instances">
                <v-col cols="4">
                  Number of Machines*
                </v-col>
                <v-col class="py-0" cols="8">
                  <v-text-field
                    v-model="instances"
                    type="number" required class="py-0 ml-1"
                    :min="1" :max="max_instances || 1"
                    :rules="instancesRules"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row v-if="restart_job_obj && restart_job_obj.product_type != 'moe' && restart_job_obj.tasks_total > 1">
                <v-col class="py-0" cols="4">
                  Restart*
                </v-col>
                <v-col class="py-0 task_selection" cols="8">
                  <v-checkbox
                    dense
                    v-model="tasks_selected"
                    value="all_tasks"
                    label="All Frames"
                    type="checkbox"
                    class="pa-0 ma-0"
                    color="primary"
                    :disabled="all_tasks"
                  ></v-checkbox>
                  <v-checkbox
                    dense
                    v-model="tasks_selected"
                    value="non_completed_tasks"
                    label="Stopped Frames"
                    type="checkbox"
                    class="pa-0 ma-0"
                    color="primary"
                    :disabled="non_completed_tasks"
                  ></v-checkbox>
                  <v-checkbox
                    dense
                    v-model="tasks_selected"
                    value="non_started_tasks"
                    label="Non-Started Frames"
                    type="checkbox"
                    class="pa-0 ma-0"
                    color="primary"
                    :disabled="non_started_tasks"
                  ></v-checkbox>
                  <v-checkbox
                    dense
                    v-model="tasks_selected"
                    value="failed_tasks"
                    label="Failed Frames"
                    type="checkbox"
                    class="pa-0 ma-0"
                    color="primary"
                    :disabled="failed_tasks"
                  ></v-checkbox>
                  <v-checkbox
                    dense
                    v-model="tasks_selected"
                    value="completed_tasks"
                    label="Completed Frames"
                    type="checkbox"
                    class="pa-0 ma-0"
                    color="primary"
                    :disabled="completed_tasks"
                  ></v-checkbox>
                  <v-checkbox
                    dense
                    v-model="tasks_selected"
                    value="selected_tasks"
                    label="Frame Range"
                    type="checkbox"
                    class="pa-0 ma-0"
                    color="primary"
                    :disabled="selected_tasks"
                  ></v-checkbox>
                </v-col>
                <v-col v-if="frame_range_input" cols="4">
                  Frames*
                </v-col>
                <v-col v-if="frame_range_input" class="py-0" cols="8">
                  <v-text-field class="py-0" label="start-end step" v-model="frame_range" :rules="frameRangeRules" required></v-text-field>
                </v-col>
                <v-col v-show="frame_range_input" cols="12">
                  <v-alert class="info my-0 pa-2" tile>
                    <span class="body-2">
                      Input format: start-end step. End and step are optional. Multiple frames ranges can be comma separated. Ex.1 or 1-5 or 5-10 2 or 3,5-10,20-50 2
                    </span>
                  </v-alert>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-alert class="my-0 pa-2" tile>
                    <span class="body-2">
                      Note: If you have updated any files then you should submit a new job.
                    </span>
                  </v-alert>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn x-small depressed color="green" @click="restart_job()">Restart</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
</template> 
<script>
  import axios from 'axios';

  export default {
    name: "RestartJobDialog",
    props: {
      restart_job_dialog: {
        type: Boolean
      },
      restart_job_obj: {
        type: Object
      },
      close_restart_job_dialog: {
        type: Function
      },
      refresh_parent: {
        type: Function
      }
    },
    data() {
      return {
        can_change_machine_type: false,
        machine_type: null,
        machines: [],
        can_change_instances: false,
        instances: 0,
        max_instances: 0,
        frame_range_input: false,
        restart_job_error: null,
        tasks_selected: [],
        all_tasks: false,
        non_completed_tasks: false,
        non_started_tasks: false,
        failed_tasks: false,
        completed_tasks: false,
        selected_tasks: false,
        frame_range: null,
        task_states: ["all_tasks", "non_completed_tasks", "non_started_tasks", "failed_tasks", "completed_tasks", "selected_tasks"],
        all_selection_blacklist: ["non_completed_tasks", "non_started_tasks", "failed_tasks", "completed_tasks"],
        frame_selection_blacklist: ["non_completed_tasks", "non_started_tasks", "failed_tasks", "completed_tasks"],
        task_selection_blacklist: ["all_tasks", "selected_tasks"],
        frameRangeRules: [
          v => this.frame_range_input && (!!v || 'Frame range is invalid')
        ],
        machineTypeRules: [
          v => !!v || 'Machine Type is invalid'
        ],
        instancesRules: [
          v => !!v || 'Invalid Number of machines',
          v => v >= 1 || `Number of machines should be atleast 1`,
          v => v <= this.max_instances || `Number of machines exceeds max throughput limit(${this.max_instances})`
        ],
      }
    },
    created() {
      this.load_restart_info();
    },
    watch: {
      tasks_selected: {
        handler () {
          if (this.tasks_selected.length == 0){
            this.all_tasks = false;
            this.non_completed_tasks = false;
            this.non_started_tasks = false;
            this.failed_tasks = false;
            this.completed_tasks = false;
            this.selected_tasks = false;
            this.frame_range_input = false;
          }else{
            if (this.tasks_selected.indexOf("all_tasks") > -1){
              this.all_tasks = false;
              this.non_completed_tasks = true;
              this.non_started_tasks = true;
              this.failed_tasks = true;
              this.completed_tasks = true;
              this.selected_tasks = true;
              this.frame_range_input = false;
            }else if(this.tasks_selected.indexOf("selected_tasks") > -1){
              this.all_tasks = true;
              this.non_completed_tasks = true;
              this.non_started_tasks = true;
              this.failed_tasks = true;
              this.completed_tasks = true;
              this.selected_tasks = false;
              this.frame_range_input = true;
            }else{
              this.all_tasks = true;
              this.non_completed_tasks = false;
              this.non_started_tasks = false;
              this.failed_tasks = false;
              this.completed_tasks = false;
              this.selected_tasks = true;
              this.frame_range_input = false;
            }
          }
        }
      }
    },
    methods:{
      close_dialog(){
        this.restart_job_error=null;
        this.close_restart_job_dialog();
      },
      restart_job(){
        var product_type = this.restart_job_obj.product_type;
        var tasks_total = this.restart_job_obj.tasks_total;
        if(this.$refs.restart_job_form.validate()) {
          if (product_type=="moe" || tasks_total == 1){
            this.post_restart_job(["all_tasks"]);
          }else{
            if (this.tasks_selected.length == 0){
              this.restart_job_error = "Restart option not selected."
            }
            else{
              this.restart_job_error = null;
              this.post_restart_job(null);
            } 
          }
        }
      },
      post_restart_job(rstrt_opts){ 
        var job_id = this.restart_job_obj.id;
        let project_id = this.restart_job_obj.group_id || this.restart_job_obj.project_id;
        var restart_options = {
          "restart_options" : rstrt_opts || this.tasks_selected
        }
        if (this.frame_range_input){
          restart_options["frames"] = this.frame_range.split("-").join(" ");
        }

        var restart_job_params = {
          "params" : restart_options,
          "machine_type" : this.machine_type.id,
          "instances" : this.instances
        }        
        axios.post(`https://${this.$buyerAPI}/projects/${project_id}/jobs/${job_id}?action=restart`, restart_job_params)
        .then(() => {
          this.restart_job_error = null;
          this.close_dialog();
          this.refresh_parent();
        })
        .catch(error => {
          var resp = error.response && error.response.data;
          if (resp && resp.error){
            this.restart_job_error = resp.error;
          }else{
            this.restart_job_error = error.message
          }
        })  
      },
      load_restart_info() {
        let job_id = this.restart_job_obj.id;
        let project_id = this.restart_job_obj.group_id || this.restart_job_obj.project_id
        axios.post(`https://${this.$buyerAPI}/projects/${project_id}/jobs/${job_id}?action=restart-info`)
        .then((resp) => {
          let restart_info = resp.data.data;
          this.can_change_machine_type = restart_info.can_change_machine_type;
          this.machines = restart_info.machines;
          this.machines.forEach(mach => {
            if (mach.is_default){
              this.machine_type = mach;
            }
          })

          this.can_change_instances = restart_info.can_change_instances;
          this.instances = restart_info.instances;
          this.max_instances = restart_info.max_instances;
        })
        .catch(error => {
          var resp = error.response && error.response.data;
          if (resp && resp.error){
            this.restart_job_error = `Unable to load restart info ${resp.error}`;
          }else{
            this.restart_job_error = error.message
          }
        })
      }
    }
  }
</script>

<style>
.v-input__slot{
  margin-bottom: 0px !important;
}
.task_selection .v-messages{
  display: none;
}
</style>